@if(partnership && partnership.cityName) {
<ng-container *ngIf="!partnership.cityName.includes('Lille'); else lille">
  <div class="flex items-center justify-start gap-6">
    <p class="text-P my-5" [innerHTML]="partnership.cityName"></p>
    <img [src]="partnership.logoPath" class="md:w-7 lg:w-[5rem]" alt="logo" />
  </div>
</ng-container>

<ng-template #lille>
  <div class="flex flex-col justify-start gap-6">
    <p class="text-P mt-5 text-center" [innerHTML]="partnership.cityName"></p>
    <img [src]="partnership.logoPath" class="mx-auto" alt="logo" />
  </div>
</ng-template>
}
<div class="container-question flex space-x-3 my-5" *ngIf="question && question.libelle !== ''">
  <img [src]="logo" class="logoPosition-h" />
  <div class="title-question flex items-center w-full justify-items-center gap-2">
    <span [innerHTML]="question.libelle" class="whitespace-pre-line"></span>
  </div>
</div>
<div class="my-5">
  <!-- DYNAMIC CONTENT -->
  <ng-content></ng-content>
</div>
<div class="flex my-5" *ngIf="popupInfo">
  <app-info-bottom *ngIf="popupInfo" [popUpInfo]="popupInfo"></app-info-bottom>
</div>

